import Big from '@web/walter-lib/big.js'
import { useRateConvert } from '@web/walter-lib/stream'
import { useGetRatesMap } from '~hooks/useRatesMap'

export function useWalletRateConvert(fromCode: string, toCode: string, amount: string) {
    const { data: ratesData, isNewRateService } = useGetRatesMap()
    const rateConvert = useRateConvert()

    if (isNewRateService) {
        return new Big(amount).times(ratesData?.[fromCode]?.price ?? 0).toString()
    } else {
        return String(rateConvert?.convertApprox(fromCode, toCode, amount) ?? 0)
    }
}
